import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import quickAboutStyle from './QuickAbout.module.scss';
import ProfileImage from '../../../assets/images/profile.png';
import { profile, stats } from '../../../data/profile';
import { RoutesUrl } from '../../../router/RouterUrls';
import ClientConfig from '../../../config';
import IButton from '../../elements/iButton/IButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const QuickAbout = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const downloadResumeHandler = () => {
        const link = document.createElement('a');
        link.href = window.location.origin + profile.resumePath;
        link.download = profile.resumeFilename;
        link.click();
    };

    return (
        <section className={quickAboutStyle.hero}>
            <div className={quickAboutStyle.backdrop} aria-hidden='true' />

            <div className={quickAboutStyle.inner}>
                <div className={quickAboutStyle.content}>
                    <span className={quickAboutStyle.status}>
                        <span className={quickAboutStyle.statusDot} />
                        {t('quickAbout.status')}
                    </span>

                    <h1 className={quickAboutStyle.title}>
                        <span className={quickAboutStyle.name}>{t('quickAbout.title')}</span>
                        <span className={quickAboutStyle.role}>{t('quickAbout.role')}</span>
                    </h1>

                    <p className={quickAboutStyle.description}>{t('quickAbout.description')}</p>

                    <div className={quickAboutStyle.actions}>
                        <IButton
                            title={t('quickAbout.viewWork')}
                            onClick={() => navigate(RoutesUrl.projects)}
                            variant='primary'
                            size='lg'
                            icon={<ArrowForwardIcon />}
                        />
                        <IButton
                            title={t('quickAbout.resume')}
                            onClick={downloadResumeHandler}
                            variant='ghost'
                            size='lg'
                            icon={<ArrowDownwardIcon />}
                        />
                    </div>

                    <div className={quickAboutStyle.meta}>
                        <span className={quickAboutStyle.metaItem}>
                            <PlaceOutlinedIcon />
                            {t('footer.location')}
                        </span>
                        <a className={quickAboutStyle.metaItem} href={`mailto:${ClientConfig.email}`}>
                            <MailOutlineIcon />
                            {ClientConfig.email}
                        </a>
                    </div>

                    <dl className={quickAboutStyle.stats}>
                        {stats.map((stat, i) => (
                            <div key={i} className={quickAboutStyle.stat}>
                                <dt className={quickAboutStyle.statValue}>{stat.value}</dt>
                                <dd className={quickAboutStyle.statLabel}>{stat.label}</dd>
                            </div>
                        ))}
                    </dl>
                </div>

                <div className={quickAboutStyle.portraitColumn}>
                    <div className={quickAboutStyle.portraitFrame}>
                        <div className={quickAboutStyle.portraitPlate}>
                            <img src={ProfileImage} className={quickAboutStyle.portrait} alt={profile.name} />
                        </div>
                        <div className={quickAboutStyle.portraitBadge}>
                            <span className={quickAboutStyle.badgeLabel}>{t('quickAbout.currently')}</span>
                            <span className={quickAboutStyle.badgeValue}>
                                {profile.role} @ {profile.company}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuickAbout;
